import React, { useEffect } from 'react'
import { ModalService } from 'services/ModalService'
import { RemoveBonusConfirm } from '@it25syv/25syv-ui'
import BonusService, { setBonusList } from 'services/BonusService'
import NotificationConductor from 'common/conductors/NotificationConductor'
import { forfeitBonus } from 'common/adapters/ProviderAdapter'
import UserService from 'services/UserService'

const ErrorType = {
    CASINO_SPIN_ONGOING: 'CASINO_SPIN_ONGOING',
}

const RemoveBonusConfirmModal = ({ data }) => {
    const { bonusAmount } = data

    const removeBonus = () => {
        forfeitBonus()
            .then((res) => {
                if (res && res.success) {
                    BonusService.removeActiveBonus()
                    UserService.setIsUserLoggedIn()
                    ModalService.closeModal('REMOVE_BONUS_CONFIRM')
                } else {
                    const hasOngoingCasinoSpin =
                        res.errorMessage === ErrorType.CASINO_SPIN_ONGOING

                    if (hasOngoingCasinoSpin) {
                        const gameName =
                            (res.data && res.data[0] && res.data[0].name) ||
                            'spillet'
                        NotificationConductor.error(
                            `Du skal afslutte dit spin på ${gameName}`
                        )
                    } else {
                        NotificationConductor.error('Something went wrong')
                    }
                    ModalService.closeModal('REMOVE_BONUS_CONFIRM')
                }
            })
            .catch((error) => {
                NotificationConductor.error(error.toString())
            })
    }

    return (
        <RemoveBonusConfirm
            currentTheme={'dark'}
            bonusAmount={bonusAmount}
            onConfirm={removeBonus}
            onCancel={() => {
                ModalService.closeModal('REMOVE_BONUS_CONFIRM')
            }}
        />
    )
}

export default RemoveBonusConfirmModal
